import Swal from 'sweetalert2';

const showSuccessMessage = (message: string) => {
  Swal.fire({ icon: 'success', text: message });
};

export default showSuccessMessage;
